import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const DashboardContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: '100%',
  backgroundColor: theme.palette.jigsaw.white,
}));